module.exports = __webpack_public_path__ + "img/twoWingsOwl.51fb8e61.svg";